import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export const stepGridColumns = () => [
    {
        field: 'from_activity',
        headerName: 'From Activity',
        width: 120,
    },
    {
        field: 'to_activity',
        headerName: 'To Activity',
        width: 120,
    },
    {
        field: 'from_activity_id',
        headerName: 'From Activity ID',
        hide: true,
    },
    {
        field: 'to_activity_id',
        headerName: 'To Activity ID',
        hide: true,
    },    
    {
        field: 'step',
        headerName: 'Step',
        hide: true,
        width: 180,
    },
    {
        field: 'tasks',
        headerName: apiProvider.getEntityUpper() + 's',
        filter: 'agNumberColumnFilter',
        width: 120,
        sort: 'desc',
        hide: false,
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatNumber({ count: value }),
    },
    {
        field: 'perc_total_tasks',
        headerName: '% ' + apiProvider.getEntityUpper() + 's',
        filter: 'agNumberColumnFilter',
        width: 120,
        hide: false,
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatPercentage({ perc: value, decimals: 1  }),
    },
    {
        field: 'events',
        headerName: 'Events',
        filter: 'agNumberColumnFilter',
        width: 120,
        type: 'rightAligned',
        hide: true,
        valueFormatter: ({ value }) =>
            apiProvider.formatNumber({ count: value }),
    },
    {
        field: 'perc_total_events',
        headerName: '% Total Events',
        filter: 'agNumberColumnFilter',
        width: 120,
        hide: true,
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatPercentage({ perc: value, decimals: 1  }),
    },
    {
        field: 'avg_duration',
        headerName: 'Avg Duration',
        filter: 'agNumberColumnFilter',
        width: 120,
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
    },
    {
        field: 'total_duration',
        headerName: 'Total Duration',
        filter: 'agNumberColumnFilter',
        width: 120,
        hide: true,
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
    },
    {
        field: 'std_deviation',
        headerName: 'Std Deviation',
        filter: 'agNumberColumnFilter',
        width: 120,
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
        hide: false,
    },
    {
        field: 'loop',
        headerName: 'Loop',
        width: 100,
    },
        {
        field: 'max_duration',
        headerName: 'Max Duration',
        filter: 'agNumberColumnFilter',
        width: 100,
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
        hide: true,
    },
    {
        field: 'min_duration',
        headerName: 'Min Duration',
        filter: 'agNumberColumnFilter',
        width: 100,
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
        hide: true,
    },
    {
        field: 'avg_duration_days',
        headerName: 'Avg Duration (days)',
        filter: 'agNumberColumnFilter',
        hide: true,
    },
    {
        field: 'std_deviation_days',
        headerName: 'Std Deviation (days)',
        filter: 'agNumberColumnFilter',
        hide: true,
    },
    {
        field: 'avg_duration_hrs',
        headerName: 'Avg Duration (hours)',
        filter: 'agNumberColumnFilter',
        hide: true,
    },
    {
        field: 'std_deviation_hrs',
        headerName: 'Std Deviation (hours)',
        filter: 'agNumberColumnFilter',
        hide: true,
    },
    {
        field: 'age',
        headerName: 'Age (Days)',
        filter: 'agNumberColumnFilter',
        width: 80,
        hide: true,
    },
    {
        field: 'worklogs',
        headerName: 'Worklogs',
        filter: 'agNumberColumnFilter',
        hide: true,
        valueFormatter: ({ value }) =>
            apiProvider.formatNumber({ count: value }),
    },
    {
        field: 'avg_worklogs',
        headerName: 'Avg Worklogs',
        filter: 'agNumberColumnFilter',
        hide: true,
        valueFormatter: ({ value }) =>
            apiProvider.formatDecimal({ value: value, decimals: 1 }),
    },
    {
        field: 'perc_worklog',
        headerName: '% Worklog',
        filter: 'agNumberColumnFilter',
        hide: true,
        valueFormatter: ({ value }) =>
            apiProvider.formatPercentage({ perc: value, decimals: 1  }),
    },
    {
        field: 'time_spent',
        headerName: 'Timespent',
        filter: 'agNumberColumnFilter',
        hide: true,
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
    },    
 
    {
        field: 'avg_time_spent',
        headerName: 'Avg Timespent',
        filter: 'agNumberColumnFilter',
        hide: true,
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
    },
   ];

